export default {
  title: 'Tablet de Fidelidade',
  headers: {
    customer_frequency: 'Frequência de clientes',
  },
};
